import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  SuiModalService,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NewDirectorModal } from '../new-director-modal/new-director-modal.component';
// import { EditDirectorModal } from '../edit-director-modal/edit-director-modal.component';
import { AolService } from '../../services/aol';
import { OrganizationService } from 'src/modules/features/admin/services/organization';

interface IDirectorRecordModalContext {
  data: any;
  title?: string;
}
@Component({
  selector: 'app-director-record-modal',
  templateUrl: './director-record-modal.component.html',
  styleUrls: ['./director-record-modal.component.scss'],
})
export class DirectorRecordModalComponent implements OnInit, OnDestroy {
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  baseUrl = environment.API_SERVER;
  success: any;
  error: any;
  pending: boolean;
  detail: any;
  item: string;
  documentData;
  organization;
  origin = [];
  constructor(
    private modalService: SuiModalService,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<IDirectorRecordModalContext, void, void>,
    private AolService: AolService,
    private organizationSvc: OrganizationService
  ) {
    this.detail = modal.context.data;
    this.organization = JSON.parse(window.localStorage.getItem('organization'));

    // console.log(this.detail, 'detail');
    this.item = this.detail.item || '';
    if (this.detail.director.photographDocumentId) {
      this.getDocumentPath(this.detail.director.photographDocumentId);
      // this.documentData = `${this.baseUrl}/public/image/?media=${this.detail.director.photographDocumentId}`;
    } else {
      this.getCountryOrigin();
    }
  }

  getCountryOrigin() {
    this.pending = true;
    this.organizationSvc
      .getCountries({ organizationId: this.organization.organizationId })
      .subscribe((res) => {
        this.pending = false;
        this.origin = res['rows'];
      });
  }

  filterResult(data) {
    let result = this.origin.filter((item) => {
      return item.countryCode === data;
    });
    return result[0]?.countryName;
  }

  getDocumentPath(data) {
    this.pending = true;
    this.AolService.getDocument({ documentId: data }).subscribe(
      (res: any) => {
        this.pending = false;
        this.getCountryOrigin();
        this.documentData = `${this.baseUrl}/public/image/?media=${res.documentPath}`;
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }
  save() {}
  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }

  editRecord(director) {
    this.modalService
      .open(
        new NewDirectorModal(
          `Edit ${this.item}`,
          {
            director: director,
            countries: this.detail.countries,
            companyType: this.detail.companyType,
            ownershipType: this.detail.ownershipType,
            item: this.item,
          },
          true,
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        // this.getPage(1);
      })
      .onDeny(() => {});
  }
}

export class DirectorRecordModal extends ComponentModalConfig<
  IDirectorRecordModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(DirectorRecordModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
